import React, { FC } from 'react';
import styled from 'styled-components';
import { format } from 'components/atoms/input-duration';
import { BaseCell } from 'components/organisms/timesheets/common/timesheet-table';

const Cell = styled(BaseCell)<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const defaultFormatter = (value: number) => value.toString();

export const DifferenceCell: FC<{
  value?: number;
  formatter?: (value: number) => string;
}> = ({ value, formatter = defaultFormatter }) => {
  const backgroundColor =
    value == null
      ? 'transparent'
      : value > 0
      ? 'var(--red-10)'
      : 'var(--green-10)';

  return (
    <Cell backgroundColor={backgroundColor}>
      {value == null ? '-' : formatter(value)}
    </Cell>
  );
};

export const DaysDifferenceCell: FC<{ value?: number }> = ({ value }) => (
  <DifferenceCell value={value} formatter={(x) => format('dd', x)} />
);

export const HoursDifferenceCell: FC<{ value?: number }> = ({ value }) => (
  <DifferenceCell value={value} formatter={(x) => format('hh', x)} />
);
